export default __webpack_public_path__ + "static/car13-27e50d5494e3003491aa7984d660c9e6.glb";